import CookiePrompt from './CookiePrompt'

export default CookiePrompt
